<!-- CONTAINER -->
<div class="container content-area relative">

  <!-- PAGE-HEADER -->
  <div class="page-header">
    <h4 class="page-title">Skills</h4>
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/admin/skills']">Skills</a></li>
      <li class="breadcrumb-item active" aria-current="page">List</li>
    </ol>
  </div>
  <!-- PAGE-HEADER END -->
  
  <!-- ROW-1 OPEN -->
<div class="row" id="user-profile">
  <div class="col-lg-12">
    <div class="card shadow-sm rounded">
      <div class="card-body">
        <!-- Modal Template -->
        <ng-template #content let-modal>
          <div class="modal-header">
            <h5 class="modal-title" id="modal-basic-title">Add Skill</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
          </div>
          <div class="modal-body">
            <form [formGroup]="addSKillsForm" (submit)="onAddSkills()">
              <div class="mb-3">
                <label class="form-label" for="skills">Skill Name</label>
                <input type="text" class="form-control" formControlName="skillname" placeholder="Enter Skill" />
                <div *ngIf="f.skillname.invalid && (f.skillname.dirty || f.skillname.touched)" class="text-danger mt-1">
                  Required
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.close('Save click')">Cancel</button>
            <button type="submit" class="btn btn-primary" (click)="onAddSkills()" [disabled]="!addSKillsForm.valid">
              Save
            </button>
          </div>
        </ng-template>

        <!-- Header Bar -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <input type="text" placeholder="Filter by skill name..." class="form-control w-50" (keyup)="updateFilter($event)" />
          <button class="btn btn-outline-primary" (click)="open(content)">+ Add Skill</button>
        </div>

        <div class="row g-3">
          @for (skill of skillsData; track skill._id) {
          <div class="col-sm-6 col-md-4 col-lg-3">
            <div class="card h-100 border shadow-sm">
              <div class="card-body text-center">
                <h6 class="card-title mb-1">{{ skill.skillname }}</h6>
                <a class="small text-decoration-underline text-primary" [routerLink]="['/admin/skills/editSkills/', skill._id]">
                  Edit
                </a>
              </div>
            </div>
          </div>
          }
        </div>

      </div>
    </div>
  </div>
</div>

  <!-- ROW-1 CLOSED -->
</div>
<!-- CONTAINER CLOSED -->
